module.exports = __webpack_public_path__ + "img/ttd-certif.a8eb70dc.png";